import React, { useState, useEffect } from 'react';
import FormContainer from '../components/FormContainer';
import config from '../appconfig/config.json';
import Loading from '../components/Loading';
import SubHeader from '../components/SubHeader';
import CusHr from '../components/CusHr';
import CusBbox from '../components/CusBbox';
import helper from '../factory/Helper.js';
import storage from '../factory/StorageFactory';
import CusSavePrint from '../components/CusSavePrint';
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import CusGreenBtn from '../components/CusGreenBtn'
import service from '../services/StatusEnquiryApiService';
import imgComplete from '../images/DisbursementComplete.png';
import imgPending from '../images/DisbursementPending.png';
import StatusEnquiryDtls from '../components/StatusEnquiryDtls';
import OpenSMEAcct from '../components/OpenSMEAcct';
 

const Disbursement = (props) => {

    const pdfExportComponent = React.useRef(null);
    const container = React.useRef(null);
 
    const [refNo, setRefNo] = useState('');
    let timer;
 
    const [response, setResponse] = useState();
    const [isLoading, setIsLoading] = useState(true); //default true;

    const [isError, setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');
 
    useEffect(() => {
        console.log('@ReviewOffer useEffect');

        window.scrollTo(0, 0);
        getPropsData();

        return () => clearTimeout(timer);
    }, []);

    const clearData = () => {
        if (storage.getStateId() !== null) {
            storage.clearAll();
        }
    }

    const getProxyUrl = () => {
        const url = helper.getPdfUrl('Submit');
        return url;
    }

    const exportPDFWithMethod = () => {
        let element = container.current || document.body;
        savePDF(element, {
            paperSize: 'auto',
            margin: 5,
            fileName: refNo + '.pdf',
            proxyUrl: getProxyUrl()
        });
    };

    const exportPDFWithComponent = () => {
        if (pdfExportComponent.current) {
            pdfExportComponent.current.save();
        }
    };

    const printPDF = () => {
        window.print();
    }

    const getPropsData = () => {   //parse form preview or resume application 
        if(props.location.state !== undefined) { //not first time
            let resData = props.location.state.response? props.location.state.response:'';
   
            setResponse(resData);
            setRefNo(resData.StatusDtls.ApplicationNo);
            setIsLoading(false);
        }
        else {
             //redirect to error 
        }
    }

    const getStatus = (uen,ic) => {
        service.getStatus(uen,ic).then( res => {
            setRefNo(res.data.StatusDtls.ApplicationNo);
            setResponse(res.data);
            setIsLoading(false);
        })
        .catch( err => {
            console.log('err: ',err);
            setIsLoading(false);
        })
    }

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout()
    }

    const setErrMsgTimeout = () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    const isStatusFailed = () => {
        let status = getStatusCodefromWAA();
        if(status.trim() === config.StatusDtls.DE || status.trim() === config.StatusDtls.RJ || status.trim() === config.StatusDtls.AB) {
            return true;
        }
        else {
            return false;
        }
    }

    const isStatusPending = () => {
        let status = getStatusCodefromWAA();
        if(status.trim() === config.StatusDtls.LA || status.trim() === config.StatusDtls.DI) {
            return true;
        }
        else {
            return false;
        }
    }

    const getStatusCodefromWAA = () => {
        const appStatusCode = response.StatusDtls.ApplicationProgress;
        // const array =appStatusCode.split('-');
        let code = appStatusCode;
        return code;
    }

    const handleBacktoHome = (e) => {
        //route url to home screen
        window.location.href = config.link.BacktoHome;
    }

    const showInterestRateLabel = () => {
        let fType = response.StatusDtls.FinancingType;
        
        if(fType.toLowerCase() === 'conventional') {
            return 'Interest Rate';
        }
        else {
            return 'Profit Rate';
        }
    }

    const showOpenCASAAcct = () => {
        let isShown = false;
        if(isStatusPending() === false) { //Disbursement Complete
            isShown = false;
        }
        else { //Disbursement Pending
            if(response.AccountDtls.AccountNum === null || response.AccountDtls.AccountNum === '') {
                isShown = true;
            }
            else {
                isShown = true;
            }
        } 

        return isShown;
    }

    const displayAcctNumber = () => {
        if(response.AccountDtls.AccountNum !== null) {
            return 'Account Number: '+response.AccountDtls.AccountNum;
        } 
        else{
            return 'Account Number:';
        }
    }

    if(isLoading) {
        return(
          <Loading />
        )
    }

    return (
        <PDFExport ref={pdfExportComponent} paperSize="auto" margin={10} fileName={refNo + '.pdf'}>
        {isStatusFailed()?
        <div className="container-fluid">
         <SubHeader title={'Oops!'} />  
         <FormContainer>
            <div style={{ fontWeight: "500",paddingTop:'20px', fontSize:'18px'}} className="box inputPair" id={'tt1'}>
             We are sorry but we are unable to proceed with the application.<br/>Application rejected. 
            </div>  
            <CusHr style={{ marginTop: '-2em' }} />
            <StatusEnquiryDtls data={response.StatusDtls} />
            <CusHr style={{ marginTop: '-2em' }} />
            <CusBbox id1="interestRate" lb1={"Interest rate (Indicative)"} val1={response.StatusDtls.InterestRate+'%'}
                id2="instalment" lb2="Instalment (Indicative)" val2={'SGD '+response.StatusDtls.Instalment} />
            <br/>
            <CusGreenBtn lbtxt='Back To Home' onClick={handleBacktoHome}  />
            <br/>
         </FormContainer>
            <br/>
        </div>
        :
        <div className="container-fluid">
            <SubHeader title={'Thank you for accepting our loan/financing offer'} />  
                <FormContainer>
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                        <img className="imgScc" alt="imgScc" src={isStatusPending()?imgPending:imgComplete} ></img>
                            {isStatusPending()?
                            <div>
                                <div style={{ fontWeight: "500",paddingTop:'10px'}} className="box" id={'tt1'}>{'Disbursement in progress'}</div>  
                                <div className="box" id={'tt2'}>{'Below are the details'}</div> 
                            </div>
                            :
                            <div>
                                <div style={{ fontWeight: "500",paddingTop:'10px'}} className="box" id={'tt1'}>{'Disbursement Completed'}</div>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <label className="box" style={{borderBottom:'solid orange', marginBottom:'15px'}} id={'tt09'}>{'Your loan has been disbursed with the following details'}</label> <br/> 
                                        <label className="box" id={'tt98'}>{displayAcctNumber()}
                                        </label> <br/> 
                                        <label className="box" id={'tt21'}>{'Date: '+response.AccountDtls.Ddate}
                                        </label>
                                    </div>
                                </div>  
                             </div>
                            }
                    </div>

                    <CusHr style={{ marginTop: '-3em' }} />
                    <StatusEnquiryDtls data={response.StatusDtls} />
                    <CusHr style={{ marginTop: '-2em' }} />

                    <CusBbox id1="interestRate" lb1={showInterestRateLabel()} val1={response.StatusDtls.InterestRate+'%'}
                        id2="instalment" lb2="Instalment" val2={'SGD '+response.StatusDtls.Instalment} />
                    <br />

                    {showOpenCASAAcct() && <div>
                        <OpenSMEAcct />
                    </div>}
                                  
                    <div className="row around-xs inputPair elementVisible">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            {isStatusPending()&&
                                <div style={{textAlign:'center'}} >
                                    {'Your loan/financing will be disbursed within 1 minute upon completion of documentation.'}<br/>
                                    {'Terms & Conditions apply.'}
                                </div> 
                            }
                        </div>
                    </div>
                    <br/>
                    <CusSavePrint lb1='Save this PDF' onClick1={exportPDFWithMethod} lb2='Print this' onClick2={printPDF} />
                    <br /> 
                    <CusGreenBtn lbtxt='Back To Home'  onClick={handleBacktoHome}   />
                    <br/>
                </FormContainer>
            <br />
        </div>
        }
        </PDFExport>
    )
}

export default Disbursement;